import { render } from "./AccountSetting.vue?vue&type=template&id=d24b2fe8&scoped=true"
import script from "./AccountSetting.vue?vue&type=script&lang=js"
export * from "./AccountSetting.vue?vue&type=script&lang=js"

import "./AccountSetting.vue?vue&type=style&index=0&id=d24b2fe8&lang=less&scoped=true"
import "./AccountSetting.vue?vue&type=style&index=1&id=d24b2fe8&lang=css"

import exportComponent from "/Users/april/Desktop/hz_pro_vue3/mail-task-front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d24b2fe8"]])

export default __exports__